module.exports = __webpack_public_path__ + "static/media/mama-burger-2023-mb-fr.fc6b9706.jpg";